/* Figma's "Hero" (36:69) and the "Hero (Section)" inside it, collapsed into one
 * box: the wrapper only ever holds the blob and the one instance, so the two
 * frames come out the same 254x83. */
.hero {
  position: relative;
  flex: none;

  display: flex;
  flex-direction: column;
  gap: calc(var(--gap) * var(--u));

  width: calc(var(--width) * var(--u));
  margin: 0;
  padding: calc(var(--pad-block) * var(--u)) calc(var(--pad-inline) * var(--u));
}

/* The blob is drawn in frame coordinates and placed against the hero, the way
 * Figma stores it: an absolutely positioned child that travels with the frame
 * rather than with the screen. */
.blob {
  position: absolute;
  left: calc(var(--blob-x) * var(--u));
  top: calc(var(--blob-y) * var(--u));
  width: calc(var(--blob-w) * var(--u));
  height: calc(var(--blob-h) * var(--u));
}

/* Over the blob — which is absolutely positioned, so without a position of
 * their own these two would paint underneath it. */
.title,
.tagline {
  position: relative;
}

.title {
  align-self: stretch;
  margin: 0;
  color: #fff;
}

.tagline {
  /* Figma's tagline text node hugs its own 154 rather than filling the frame
   * it sits in. Same ink either way, but the box is the thing a future link
   * would be clickable over. */
  align-self: flex-start;
  margin: 0;
  margin-left: calc(var(--tagline-indent) * var(--u));
  color: #decccc;
}
